import { Coding } from "@medplum/fhirtypes";

import { SNOMEDCodes } from "@/fhir/enums/snomed";
import { Systems } from "@/fhir/enums/systems";

export const PREGNANCY_RECORD_CODING: Coding = {
  system: Systems.SNOMED,
  code: SNOMEDCodes.PregnancyRecord,
  display: "Pregnancy Record",
} as const;

export const PREGNANCY_RECORD_CODING_QUERY = `${PREGNANCY_RECORD_CODING.system}|${PREGNANCY_RECORD_CODING.code}`;
